<template>
  <div ref="body">
    <custom-header active="exh" :subActive="current"></custom-header>

    <div class="brand-detail-container">
      <div class="brand-header">
        <div class="brand-header-inner">
          <div class="brand-header-left" v-if="brandLogo">
            <img :src="brandLogo" :alt="brandName" class="brand-logo" />
          </div>
          <div class="brand-header-right">
            <h1 class="brand-title" v-if="brandName">{{ brandName }}</h1>
            <h2 class="brand-company" v-if="brandCompany">{{ brandCompany }}</h2>
            <div class="brand-meta" v-if="metaTags.length > 0">
              <span class="meta-tag" v-for="(tag, idx) in metaTags" :key="idx">{{ tag }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="brand-content">
        <div class="breadcrumb">
          <a href="/exhibitor">Exhibitors</a>
          <span class="separator">/</span>
          <span class="current">{{ brandName || 'Brand Detail' }}</span>
        </div>

        <div class="main-content">
          <div class="left-section">
            <div class="section about-section" v-if="brandInfo.companyDesc || brandInfo.brandDesc">
              <h2 class="section-title">About Brand</h2>
              <div class="section-content">
                <p class="brand-description">{{ brandInfo.companyDesc || brandInfo.brandDesc }}</p>
              </div>
            </div>

            <div class="section gallery-section" v-if="productImages.length > 0">
              <h2 class="section-title">Product Gallery</h2>
              <div class="section-content">
                <div class="gallery-main" v-if="currentImageIndex >= 0">
                  <img :src="productImages[currentImageIndex]" class="main-image" alt="Product Image" />
                  <div class="gallery-nav" v-if="productImages.length > 1">
                    <button class="nav-btn prev" @click="prevImage">
                      <van-icon name="arrow-left" />
                    </button>
                    <button class="nav-btn next" @click="nextImage">
                      <van-icon name="arrow" />
                    </button>
                  </div>
                </div>
                <div class="gallery-thumbs" v-if="productImages.length > 1">
                  <div
                    v-for="(img, idx) in productImages"
                    :key="idx"
                    :class="['thumb-item', currentImageIndex === idx ? 'active' : '']"
                    @click="currentImageIndex = idx"
                  >
                    <img :src="img" alt="Thumbnail" />
                  </div>
                </div>
              </div>
            </div>

            <div class="section profile-section" v-if="profileItems.length > 0">
              <h2 class="section-title">Company Profile</h2>
              <div class="section-content">
                <div class="profile-grid">
                  <div class="profile-item" v-for="(item, idx) in profileItems" :key="idx">
                    <span class="profile-label">{{ item.label }}</span>
                    <span class="profile-value">{{ item.value }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="section video-section" v-if="brandInfo.videoUrl">
              <h2 class="section-title">Brand Video</h2>
              <div class="section-content">
                <div class="video-wrapper">
                  <video
                    :src="brandInfo.videoUrl"
                    controls
                    class="brand-video"
                  >
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>
          </div>

          <div class="right-section">
            <div class="sidebar-card quick-card">
              <div class="qr-main" v-if="brandInfo.qrCode">
                <img :src="brandInfo.qrCode" class="qr-img" alt="QR Code" />
                <p class="qr-tip">Scan QR Code to Follow</p>
              </div>
              <div class="quick-info" v-if="quickItems.length > 0">
                <div class="quick-item" v-for="(item, idx) in quickItems" :key="idx">
                  <van-icon :name="item.icon" class="quick-icon" />
                  <div class="quick-text">
                    <span class="quick-label">{{ item.label }}</span>
                    <span class="quick-value">{{ item.value }}</span>
                  </div>
                </div>
              </div>
  
              <button class="inquiry-btn" @click="jumpInquiry">
                 <!-- @click="showInquiryForm = true" -->
                Send Inquiry
              </button>
            </div>

            <div class="sidebar-card tag-card" v-if="categories.length > 0">
              <h3 class="card-title">Product Categories</h3>
              <div class="category-list">
                <span class="category-tag" v-for="(cat, idx) in categories" :key="idx">
                  {{ cat }}
                </span>
              </div>
            </div>

             <!-- 分享屏蔽
            <div class="sidebar-card share-card">
              <h3 class="card-title">Share Brand</h3>
              <div class="share-buttons">
                <button class="share-btn" @click="shareTo('facebook')">
                  <span class="share-icon">f</span>
                  <span>Facebook</span>
                </button>
                <button class="share-btn" @click="shareTo('twitter')">
                  <span class="share-icon">t</span>
                  <span>Twitter</span>
                </button>
                <button class="share-btn" @click="shareTo('linkedin')">
                  <span class="share-icon">in</span>
                  <span>LinkedIn</span>
                </button>
                <button class="share-btn" @click="shareTo('whatsapp')">
                  <span class="share-icon">w</span>
                  <span>WhatsApp</span>
                </button>
              </div>
            </div>
            -->
          </div>
        </div>
      </div>
    </div>

    <van-overlay :show="showInquiryForm" z-index="100" @click="showInquiryForm = false">
      <div class="inquiry-modal" @click.stop>
        <div class="modal-header">
          <h3 class="modal-title">Send Inquiry to {{ brandName }}</h3>
          <van-icon name="cross" class="close-icon" @click="showInquiryForm = false" />
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">Your Name *</label>
            <input type="text" v-model="inquiryForm.name" class="form-input" placeholder="Please enter your name" />
          </div>
          <div class="form-group">
            <label class="form-label">Email *</label>
            <input type="email" v-model="inquiryForm.email" class="form-input" placeholder="Please enter your email" />
          </div>
          <div class="form-group">
            <label class="form-label">Company</label>
            <input type="text" v-model="inquiryForm.company" class="form-input" placeholder="Please enter your company name" />
          </div>
          <div class="form-group">
            <label class="form-label">Phone</label>
            <input type="tel" v-model="inquiryForm.phone" class="form-input" placeholder="Please enter your phone number" />
          </div>
          <div class="form-group">
            <label class="form-label">Message *</label>
            <textarea v-model="inquiryForm.message" class="form-textarea" rows="5" placeholder="Please enter your inquiry message"></textarea>
          </div>
          <button class="submit-btn" @click="submitInquiry">
            Send Inquiry
          </button>
        </div>
      </div>
    </van-overlay>

    <custom-footer :friendLink="friendLink"></custom-footer>
    <scroll-top @scrollTop="scrollTop"></scroll-top>
  </div>
</template>

<script>
import { Icon, Overlay } from 'vant';
import customHeader from "./components/head.vue";
import customFooter from "./components/foot.vue";
import scrollTop from "./components/scrollTop.vue";
import commonMixin from './commonMixin.js';
import { getExhibitorDetailEn, submitSourcing } from '@/api/index.js'

function cleanNull(val) {
  if (val === null || val === undefined) return '';
  if (typeof val === 'string' && val.toLowerCase() === 'null') return '';
  return val;
}

export default {
  name: 'BrandDetail',
  components: {
    'custom-header': customHeader,
    'custom-footer': customFooter,
    'scroll-top': scrollTop,
    [Icon.name]: Icon,
    [Overlay.name]: Overlay,
  },
  mixins: [commonMixin],
  metaInfo: {
    title: 'Shenzhen China World Exhibition Week: All Exhibitor Categories', // set a title
    meta: [
      { name: 'keyWords', content: 'Furniture Fair,Home Design,Furniture Exhibitor,Home Furnishing Forum,Design Week,Home Design Week' },
      { name: 'description', content: 'Shenzhen China International Furniture Exhibition & Creative Week 2027: Check Out the Details of the Participating Exhibitors Category-wise Here!  '},
    ],
  },
  data() {
    return {
      current: 'exhibitor',
      brandInfo: {},
      currentImageIndex: 0,
      showInquiryForm: false,
      inquiryForm: {
        name: '',
        email: '',
        company: '',
        phone: '',
        message: '',
      },
      friendLink: [],
    };
  },
  computed: {
    brandName() {
      return this.brandInfo.brandName || this.brandInfo.companyName || '';
    },
    brandCompany() {
      return this.brandInfo.companyName || this.brandInfo.brandName || '';
    },
    brandLogo() {
      return this.brandInfo.logo || '';
    },
    metaTags() {
      let tags = [];
      if (this.brandInfo.series) {
        tags = this.brandInfo.series.split(/[;,；、]/).filter(t => t.trim());
      }
      return tags;
    },
    productImages() {
      let images = [];
      if (this.brandInfo.banners) {
        images.push(this.brandInfo.banners);
      }
      let picStr = this.brandInfo.productPictures;
      if (picStr) {
        let pics = picStr.split(';').filter(img => img.trim());
        images = images.concat(pics);
      }
      return images;
    },
    categories() {
      if (this.brandInfo.categories) {
        return this.brandInfo.categories.split(/[;,；、]/).filter(cat => cat.trim());
      }
      return [];
    },
    profileItems() {
      let items = [];
      if (this.brandInfo.series) {
        items.push({ label: 'Exhibition Series', value: this.brandInfo.series });
      }
      if (this.brandInfo.categories) {
        items.push({ label: 'Main Categories', value: this.brandInfo.categories });
      }
      if (this.brandInfo.product) {
        items.push({ label: 'Main Products', value: this.brandInfo.product });
      }
      if (this.brandInfo.productStyle) {
        items.push({ label: 'Product Style', value: this.brandInfo.productStyle });
      }
      if (this.brandInfo.material) {
        items.push({ label: 'Material', value: this.brandInfo.material });
      }
      if (this.brandInfo.businessModel) {
        items.push({ label: 'Business Model', value: this.brandInfo.businessModel });
      }
      if (this.brandInfo.designer) {
        items.push({ label: 'Designer', value: this.brandInfo.designer });
      }
      return items;
    },
    quickItems() {
      let items = [];
      if (this.brandInfo.phone) {
        items.push({ icon: 'phone', label: 'Phone', value: '0086 ' + this.brandInfo.phone });
      }
      if (this.brandInfo.address) {
        items.push({ icon: 'location-o', label: 'Address', value: this.brandInfo.address });
      }
      if (this.brandInfo.positionCode) {
        items.push({ icon: 'cluster-o', label: 'Booth No.', value: this.brandInfo.positionCode });
      }
      return items;
    },
  },
  created() {
    let { id } = this.$route.query;
    if (id) {
      this.getBrandDetail(id);
    }
  },
  methods: {
    getBrandDetail(id) {
      getExhibitorDetailEn(id).then(res => {
        let data = res.resultData || {};
        let addressParts = [cleanNull(data.province), cleanNull(data.city), cleanNull(data.district), cleanNull(data.addressDetail)].filter(Boolean);
        this.brandInfo = {
          brandName: cleanNull(data.brandName) || cleanNull(data.companyName),
          brandDesc: cleanNull(data.brandDesc) || cleanNull(data.companyDesc),
          companyName: cleanNull(data.companyName) || cleanNull(data.brandName),
          companyDesc: cleanNull(data.companyDesc) || cleanNull(data.brandDesc),
          logo: cleanNull(data.logo),
          banners: cleanNull(data.banners),
          series: cleanNull(data.series),
          categories: cleanNull(data.categories),
          product: cleanNull(data.product),
          productStyle: cleanNull(data.productStyle),
          material: cleanNull(data.material),
          businessModel: cleanNull(data.businessModel),
          phone: cleanNull(data.phone),
          address: addressParts.length > 0 ? addressParts.join(', ') : '',
          qrCode: cleanNull(data.qrCode),
          productPictures: cleanNull(data.productPictures),
          positionCode: cleanNull(data.positionCode),
          designer: cleanNull(data.designer),
          mailbox: cleanNull(data.mailbox),
        };
        this.currentImageIndex = 0;
      }).catch(() => {
        this.brandInfo = {
          brandName: '',
          brandDesc: '',
          companyName: '',
          companyDesc: '',
          logo: '',
          banners: '',
          series: '',
          categories: '',
          product: '',
          productStyle: '',
          material: '',
          businessModel: '',
          phone: '',
          address: '',
          qrCode: '',
          productPictures: '',
          positionCode: '',
          designer: '',
          mailbox: '',
        };
      });
    },
    prevImage() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--;
      } else {
        this.currentImageIndex = this.productImages.length - 1;
      }
    },
    nextImage() {
      if (this.currentImageIndex < this.productImages.length - 1) {
        this.currentImageIndex++;
      } else {
        this.currentImageIndex = 0;
      }
    },
    jumpInquiry(){
      //跳转采购需求界面
      this.$router.push({ path: '/sourcing' })
    },
    submitInquiry() { 
      if (!this.inquiryForm.name || !this.inquiryForm.email || !this.inquiryForm.message) {
        this.$toast('Please fill in all required fields');
        return;
      }
      let params = {
        name: this.inquiryForm.name,
        email: this.inquiryForm.email,
        company: this.inquiryForm.company,
        phone: this.inquiryForm.phone,
        content: this.inquiryForm.message,
        exhibitorId: this.$route.query.id || '',
      };
      submitSourcing(params).then(res => {
        this.$toast.success('Inquiry sent successfully!');
        this.showInquiryForm = false;
        this.inquiryForm = { name: '', email: '', company: '', phone: '', message: '' };
      }).catch(() => {
        this.$toast('Failed to send inquiry, please try again later');
      });
    },
    shareTo(platform) {
      let url = window.location.href;
      let title = this.brandName + ' - Shenzhen Creative Week';
      let shareUrl = '';
      switch(platform) {
        case 'facebook':
          shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
          break;
        case 'twitter':
          shareUrl = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(title);
          break;
        case 'linkedin':
          shareUrl = 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(url);
          break;
        case 'whatsapp':
          shareUrl = 'https://api.whatsapp.com/send?text=' + encodeURIComponent(title + ' ' + url);
          break;
      }
      if (shareUrl) {
        window.open(shareUrl, '_blank', 'width=600,height=400');
      }
    },
  },
};
</script>

<style scoped lang="less">
.brand-detail-container {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.brand-header {
  width: 100%;
  background: linear-gradient(135deg, #1a1a2e 0%, #2d2d44 50%, #3d3d5c 100%);
  padding: 40Px 0;

  .brand-header-inner {
    max-width: 1200Px;
    margin: 0 auto;
    padding: 0 40Px;
    display: flex;
    align-items: center;
    gap: 40Px;
  }

  .brand-header-left {
    flex-shrink: 0;
  }

  .brand-logo {
    width: 140Px;
    height: 140Px;
    border-radius: 12Px;
    object-fit: cover;
    background: #fff;
    padding: 8Px;
    box-shadow: 0 4Px 20Px rgba(0, 0, 0, 0.3);
  }

  .brand-header-right {
    flex: 1;
  }

  .brand-title {
    font-size: 36Px;
    font-weight: bold;
    color: #fff;
    margin: 0 0 8Px 0;
    font-family: 'Poppins-Bold';
    letter-spacing: 1Px;
  }

  .brand-company {
    font-size: 18Px;
    color: #c29441;
    margin: 0 0 16Px 0;
    font-weight: 500;
  }

  .brand-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 10Px;
  }

  .meta-tag {
    padding: 6Px 16Px;
    background: rgba(194, 148, 65, 0.2);
    border: 1Px solid rgba(194, 148, 65, 0.5);
    border-radius: 20Px;
    font-size: 13Px;
    color: #c29441;
  }
}

.brand-content {
  max-width: 1200Px;
  margin: 0 auto;
  padding: 30Px 40Px 60Px;
}

.breadcrumb {
  margin-bottom: 24Px;
  font-size: 14Px;
  color: #666;

  a {
    color: #666;
    text-decoration: none;

    &:hover {
      color: #060211;
    }
  }

  .separator {
    margin: 0 10Px;
    color: #ccc;
  }

  .current {
    color: #333;
    font-weight: 500;
  }
}

.main-content {
  display: flex;
  gap: 30Px;
}

.left-section {
  flex: 1;
  min-width: 0;
}

.right-section {
  width: 320Px;
  flex-shrink: 0;
}

.section {
  background: #fff;
  border-radius: 8Px;
  margin-bottom: 24Px;
  overflow: hidden;

  .section-title {
    font-size: 22Px;
    font-weight: bold;
    color: #060211;
    padding: 24Px 28Px 0;
    margin: 0;
    font-family: 'Poppins-Bold';
    position: relative;

    &::after {
      content: '';
      display: block;
      width: 40Px;
      height: 3Px;
      background: #c29441;
      margin-top: 12Px;
      border-radius: 2Px;
    }
  }

  .section-content {
    padding: 24Px 28Px 28Px;
  }
}

.about-section {
  .brand-description {
    font-size: 15Px;
    line-height: 1.8;
    color: #555;
    margin: 0;
  }
}

.gallery-section {
  .gallery-main {
    position: relative;
    width: 100%;
    height: 450Px;
    background: #f8f8f8;
    border-radius: 8Px;
    overflow: hidden;
    margin-bottom: 16Px;

    .main-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .gallery-nav {
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      transform: translateY(-50%);
      display: flex;
      justify-content: space-between;
      padding: 0 20Px;

      .nav-btn {
        width: 48Px;
        height: 48Px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.9);
        border: none;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20Px;
        color: #333;
        transition: all 0.3s;

        &:hover {
          background: #fff;
          transform: scale(1.1);
        }
      }
    }
  }

  .gallery-thumbs {
    display: flex;
    gap: 12Px;
    overflow-x: auto;
    padding-bottom: 8Px;

    .thumb-item {
      flex-shrink: 0;
      width: 100Px;
      height: 75Px;
      border-radius: 6Px;
      overflow: hidden;
      cursor: pointer;
      border: 2Px solid transparent;
      transition: border-color 0.3s;

      &.active {
        border-color: #c29441;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}

.profile-section {
  .profile-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0;
  }

  .profile-item {
    display: flex;
    flex-direction: column;
    padding: 16Px 0;
    border-bottom: 1Px solid #f0f0f0;

    &:nth-child(odd) {
      padding-right: 24Px;
    }

    .profile-label {
      font-size: 13Px;
      color: #999;
      margin-bottom: 6Px;
    }

    .profile-value {
      font-size: 15Px;
      color: #333;
      font-weight: 500;
      line-height: 1.5;
    }
  }
}

.video-section {
  .video-wrapper {
    width: 100%;
    border-radius: 8Px;
    overflow: hidden;
    background: #000;

    .brand-video {
      width: 100%;
      height: auto;
      display: block;
    }
  }
}

.sidebar-card {
  background: #fff;
  border-radius: 8Px;
  padding: 24Px;
  margin-bottom: 20Px;

  .card-title {
    font-size: 18Px;
    font-weight: bold;
    color: #060211;
    margin: 0 0 20Px 0;
    padding-bottom: 12Px;
    border-bottom: 1Px solid #f0f0f0;
    font-family: 'Poppins-Bold';
  }
}

.quick-card {
  text-align: center;

  .qr-main {
    margin-bottom: 20Px;

    .qr-img {
      width: 160Px;
      height: 160Px;
      border-radius: 8Px;
      border: 1Px solid #eee;
      padding: 8Px;
      background: #fff;
    }

    .qr-tip {
      font-size: 13Px;
      color: #999;
      margin: 10Px 0 0 0;
    }
  }

  .quick-info {
    text-align: left;
    margin-bottom: 20Px;
  }

  .quick-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 16Px;

    &:last-child {
      margin-bottom: 0;
    }

    .quick-icon {
      font-size: 18Px;
      color: #c29441;
      margin-right: 12Px;
      margin-top: 2Px;
      flex-shrink: 0;
    }

    .quick-text {
      flex: 1;

      .quick-label {
        display: block;
        font-size: 12Px;
        color: #999;
        margin-bottom: 4Px;
      }

      .quick-value {
        display: block;
        font-size: 14Px;
        color: #333;
        line-height: 1.5;
        word-break: break-all;
      }
    }
  }

  .inquiry-btn {
    width: 100%;
    height: 44Px;
    background: linear-gradient(135deg, #c29441, #d4a855);
    color: #fff;
    border: none;
    border-radius: 6Px;
    font-size: 15Px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background: linear-gradient(135deg, #d4a855, #c29441);
      transform: translateY(-1Px);
      box-shadow: 0 4Px 12Px rgba(194, 148, 65, 0.4);
    }
  }
}

.tag-card {
  .category-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10Px;
  }

  .category-tag {
    padding: 6Px 14Px;
    background: #f5f5f5;
    border-radius: 20Px;
    font-size: 13Px;
    color: #666;
  }
}

.share-card {
  .share-buttons {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12Px;
  }

  .share-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6Px;
    height: 40Px;
    border: 1Px solid #e0e0e0;
    border-radius: 6Px;
    background: #fff;
    font-size: 13Px;
    color: #666;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      border-color: #c29441;
      color: #c29441;
    }

    .share-icon {
      width: 20Px;
      height: 20Px;
      border-radius: 50%;
      background: #f0f0f0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12Px;
      font-weight: bold;
    }
  }
}

.inquiry-modal {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 500Px;
  max-height: 90vh;
  background: #fff;
  border-radius: 12Px;
  overflow: hidden;

  .modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20Px 24Px;
    border-bottom: 1Px solid #f0f0f0;

    .modal-title {
      font-size: 18Px;
      font-weight: bold;
      color: #060211;
      margin: 0;
    }

    .close-icon {
      font-size: 20Px;
      color: #999;
      cursor: pointer;

      &:hover {
        color: #666;
      }
    }
  }

  .modal-body {
    padding: 24Px;
    max-height: calc(90vh - 80Px);
    overflow-y: auto;
  }

  .form-group {
    margin-bottom: 18Px;

    .form-label {
      display: block;
      font-size: 14Px;
      color: #333;
      margin-bottom: 8Px;
      font-weight: 500;
    }

    .form-input,
    .form-textarea {
      width: 100%;
      padding: 10Px 14Px;
      border: 1Px solid #e0e0e0;
      border-radius: 6Px;
      font-size: 14Px;
      color: #333;
      box-sizing: border-box;
      transition: border-color 0.3s;
      font-family: inherit;

      &:focus {
        outline: none;
        border-color: #c29441;
      }
    }

    .form-textarea {
      resize: vertical;
    }
  }

  .submit-btn {
    width: 100%;
    height: 46Px;
    background: linear-gradient(135deg, #c29441, #d4a855);
    color: #fff;
    border: none;
    border-radius: 6Px;
    font-size: 16Px;
    font-weight: bold;
    cursor: pointer;
    margin-top: 8Px;
    transition: all 0.3s;

    &:hover {
      background: linear-gradient(135deg, #d4a855, #c29441);
    }
  }
}

@media screen and (max-width: 1023px) {
  .brand-header {
    padding: 24px 0;

    .brand-header-inner {
      flex-direction: column;
      padding: 0 16px;
      gap: 16px;
      text-align: center;
    }

    .brand-logo {
      width: 100px;
      height: 100px;
      padding: 6px;
    }

    .brand-title {
      font-size: 24px;
      letter-spacing: 0.5px;
    }

    .brand-company {
      font-size: 15px;
    }

    .brand-meta {
      justify-content: center;
    }
  }

  .brand-content {
    padding: 16px;
  }

  .main-content {
    flex-direction: column;
  }

  .right-section {
    width: 100%;
  }

  .section {
    .section-title {
      font-size: 18px;
      padding: 20px 20px 0;

      &::after {
        margin-top: 10px;
      }
    }

    .section-content {
      padding: 20px;
    }
  }

  .profile-section {
    .profile-grid {
      grid-template-columns: 1fr;
    }

    .profile-item {
      padding-right: 0 !important;
    }
  }

  .gallery-section {
    .gallery-main {
      height: 250px;
    }

    .gallery-thumbs {
      .thumb-item {
        width: 70px;
        height: 52px;
      }
    }
  }

  .inquiry-modal {
    width: 90%;
    max-width: 400px;

    .modal-header {
      padding: 16px 20px;
    }

    .modal-body {
      padding: 20px;
    }
  }
}
</style>
